<template>
  <html-preview
    v-if="isShowHTMLPreviewModal"
    @close="close"
    :isShowBasicInfo="!isNew"
  />
</template>
<script>
import HtmlPreview from '@/components/Content/Check/HTMLPreview'
export default {
  components: {
    HtmlPreview
  },
  props: [
    'isNew',
  ],
  data () {
    return {
      isShowHTMLPreviewModal: false
    }
  },
  async created () {
    let json = null
    if (this.isNew) {
      json = await this.$store.dispatch('getDefaultContent', {
        contentType: this.$route.params.contentType,
        contentId: this.$route.params.id
      })
    } else {
      json = await this.$store.dispatch('getContent', this.$route.params.id)
    }
    if (json.status === 404) {
      // どこかをクリックしたらタブを閉じる
      document.body.addEventListener('click', this.close)
      return
    }
    this.isShowHTMLPreviewModal = true
  },
  methods: {
    close () {
      window.close()
    },
  }
}
</script>
